import React, { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { navigate } from "@reach/router";
import LoginForm from "../components/auth/LoginForm";

const Login = () => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (user !== null) {
      navigate("/mytbm");
    }
  }, [user]);

  return (
    <div className="container-fluid bg-light">
      <div className="row">
        <div className="col-12 col-md-6 bg-black vh-100 px-0 hide-mobile bg-dark">
          <div className="bg-vertical"></div>
        </div>
        <div className="col-12 col-md-6 vh-100">
          <div className="row align-items-center vh-100">
            <div className="container-fluid">
              <h1 className="text-center my-4">Entrar Ahora</h1>
              <LoginForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
